var INFINITE_PREFIX = '$inf$';
export { INFINITE_PREFIX };
